import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';


type IApiResponse = {
  Item: any;
  erro: string;
}

interface IPaginateAutorizacaoParams {
  [key: string]: any;
  operacao?: string;
  empresa: string;
}


@Injectable()
export class AutorizacaoServicoProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  getById(id: string | number) : Promise<IApiResponse>
  {
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      const url = APIService.API_URL + 'autorizacaodeservico?operacao=getById&id=' + id;

      this.http.get(url, {headers: this.header}).subscribe({
        next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
        error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
      })
    });
  }

  getAutorizacoesDeServico(pagina: number, params: IPaginateAutorizacaoParams) : Promise<{data: any[], linhas: number, erro?: string, status_ret?: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=pageView&pagina=' + pagina + '&';

      const uri = new URL(url);

      Object.keys(params).forEach(key => {
        if(!params[key])
          return;
        uri.searchParams.append(key, params[key]);
      });
      
      url = uri.toString();
      
      me.http.get(url, {headers: this.header}).subscribe((result: {data: any[], linhas: number, erro?: string, status_ret?: string}) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  
  getAutorizacoesDeServicoChat(idAutorizacaoServico: string | number, chatLojista: boolean = true) : Promise<IApiResponse>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico';

      me.http.get(url, {headers: this.header, params: {
        operacao: chatLojista ? 'chatLojista' : 'chatInterno',
        idAutorizacaoServico: idAutorizacaoServico
      }}).subscribe((result: any) => {
        if(result && result.status_ret == "NOK")
        {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      },
      (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });

  }

  getAutorizacoesDeServicoJustificativa(idAutorizacaoServico: string | number) : Promise<IApiResponse> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico';

      me.http.get(url, {headers: this.header, params: {
        operacao: 'justificativa',
        idAutorizacaoServico: idAutorizacaoServico
      }}).subscribe((result: any) => {
        if(result && result.status_ret == "NOK") {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      }, (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });
  }

  getPaginatedColaboradoresAutorizados(paginacao: ApiPaginate) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=colaboradoresAutorizados&' + paginacao.geraAPIUrl();
      // let url = APIService.API_URL + 'autorizacaodeservico?operacao=colaboradoresAutorizados';

      // if(filtroPerfil != "") {
      //   url += "&perfil=" + filtroPerfil;
      // }

      // if(filtroLojistaShopping != "") {
      //   url += "&shopping=" + filtroLojistaShopping;
      // }

      // if(filtroLojistaLoja != "") {
      //   url += "&loja=" + filtroLojistaLoja;
      // }

      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getColaboradoresAutorizados(pagina: number = 0, rowsPerPage: number = 10) : Promise<IApiResponse>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=colaboradoresAutorizados';

      me.http.get(url, {headers: this.header, params: {
        pagina,
        rowsPerPage
      }}).subscribe((result: any) => {
        if(result && result.status_ret == "NOK")
        {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      },
      (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });

  }

  addUpdateComentarioAutorizacaoServico(data: any) : Promise<IApiResponse>{
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=comentario';
      
      me.http.post(url, data, {headers: this.header}).subscribe((result: any) => {
        if(result && result.status_ret == "NOK")
        {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      },
      (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });

  }

  addUpdateEntradaAutorizacaoServico(data: any) : Promise<IApiResponse>{
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=entrada';
      
      me.http.post(url, data, {headers: this.header}).subscribe((result: any) => {
        if(result && result.status_ret == "NOK")
        {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      },
      (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });
  }

  addUpdateAutorizacaoServico(data: any, params = {}): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico';

      me.http.post(url, data, { headers: this.header, params }).subscribe((result: any) => {
        if(result && result.status_ret == "NOK")
        {
          return reject({
            Item: result,
            erro: result.erro
          });
        }

        resolve({
          Item: result,
          erro: ''
        });
      },
      (error) => {
        reject({
          Item: null,
          erro: error.message
        });
      });
    });
  }

  getLidos(idComunicacao: number | string): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=lido&idComunicacao=' + idComunicacao;

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  postLeitura(idComunicacao: number | string): Promise<any>
  {
    var me=this;

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=lido&idComunicacao=' + idComunicacao;

      me.http.post(url, null, {
        headers: APIService.header
      }).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  delete(id:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'comunicacao?id=' + id;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  deleteVeiculo(idAutorizacao: any, idVeiculo: any): Promise<{Item:any, erro:string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=veiculo&id=' + idVeiculo + '&idAutorizacao=' + idAutorizacao;
      
      me.http.delete(url, { headers: me.header }).subscribe((result: any) => {
        var jsonData = result;

        if (jsonData.length != 0) {
          if (jsonData.status_ret != "NOK") {
            var datasuccess = {
              'Item': jsonData,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Erro na exclusão do veículo.'
            }

            me.itemret = errodatavazio;
          }
          
          resolve(me.itemret);
        } else {
          var errodatavazio1 = {
            'Item': null,
            'erro': 'Nenhum registro encontrado.'
          }

          me.itemret = errodatavazio1;
        }
      }, (error) => {
        var msg = "";
        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);        
      });
    });
  }

  deleteColaborador(idAutorizacao: any, idColaborador: any): Promise<{Item:any, erro:string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=colaborador&id=' + idColaborador + '&idAutorizacao=' + idAutorizacao;
      
      me.http.delete(url, { headers: me.header }).subscribe((result: any) => {
        var jsonData = result;

        if (jsonData.length != 0) {
          if (jsonData.status_ret != "NOK") {
            var datasuccess = {
              'Item': jsonData,
              'erro': ''
            }

            me.itemret = datasuccess;
          } else {
            var errodatavazio = {
              'Item': null,
              'erro': 'Erro na exclusão do colaborador.'
            }

            me.itemret = errodatavazio;
          }
          
          resolve(me.itemret);
        } else {
          var errodatavazio1 = {
            'Item': null,
            'erro': 'Nenhum registro encontrado.'
          }

          me.itemret = errodatavazio1;
        }
      }, (error) => {
        var msg = "";
        if (error.status == 401) {
          msg = error.statusText;
        } else {
          msg = error.error;
        }

        let errojson = msg;

        var errochamada = {
          'Item': null,
          'erro': errojson
        }

        me.itemret = errochamada;
        reject(me.itemret);        
      });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do comunicado
   * @returns 
   */
  add(dadosJson: any): Promise<IApiResponse> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'comunicacao';


      //console.log(requestData);
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }
  
  getFilesByIds(ids: string[] | number[]): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'autorizacaodeservico?operacao=arquivos&ids=' + ids.join(',');

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
}
